import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { TimestampCreator } from '@leverege/api-attributes'
import { TextInput } from '~/views'
import Util from './Util'

export default class TimestampEditor extends React.Component {

  static TYPE = TimestampCreator.typeName();

  static propTypes = {
    attribute : PropTypes.object,
    name : PropTypes.string,
    value : PropTypes.number,
    onChange : PropTypes.func.isRequired
  }

  constructor( props ) {
    super( props )
    this.state = { error : false }
    // this.onChange = Util.onChange.bind( this )
  }

  // THIS IS NOT UI_ELEMENTS TEXTINPUT!!!!
  onChange = ( v ) => {
    if ( v === '' ) {
      this.props.onChange( { attribute : this.props.attribute, value : null } )
      return
    }
    
    let val = Number( v )
    if ( Number.isNaN( val ) ) {
      const d = new Date( v )
      if ( Number.isNaN( Number( d.getTime() ) ) ) {
        this.setState( { error : true } )
        return
      }
      val = d.getTime()
      this.props.onChange( { attribute : this.props.attribute, value : d.getTime() } );
      return
    } 
    this.setState( { error : false } )
    this.props.onChange( { attribute : this.props.attribute, value : val } )
  }

  shouldComponentUpdate( nextProps, nextState ) {
    return false
  }
  
  render() {
    const { error } = this.state
    const { attribute : attr, value, focus, changeOnBlur } = this.props
    if ( attr == null ) {
      return <div />
    }
 
    return (
      <div>
        <TextInput
          hint="Set timestamp..." 
          value={value} 
          focus={focus}
          error={error}
          data-error={error}
          validator={validator}
          changeOnBlur={changeOnBlur || false}
          onChange={this.onChange} />
      </div>
    ) 
  }
}

function validator( val ) {
  if ( val == null || val == '' ) {
    return true;
  }
  let toUse = val
  if ( Number( val ).toString() === val ) {
    toUse = Number( val )
  }
  try {
    return moment( toUse ).isValid()
    // let date = new Date( value )
    // if ( isNaN( date.getTime() ) ) {
    //   if ( typeof value === 'string' ) {
    //     let pn = parseInt( value )
    //     if ( !isNaN( pn ) ) {
    //       if ( pn.toString().length == value.length ) {
    //         // unix time
    //         return true
    //       } 
    //     } 
    //   }
    //   return false
    // }

  } catch ( err ) {
    console.log( err )
    return false
  }
  return false
}
